export type FooterLink = Record<
  LinkHeader,
  Array<{ translationKey?: string; label: string; to: string }>
>;

const links = {
  'Home Security': [
    {
      translationKey: 'home-security.home-security',
      label: 'Home Security',
      to: '/products/home-security/',
    },
    {
      translationKey: 'home-security.alarm-panel-hub',
      label: 'Alarm Panel and Hub',
      to: '/products/alarm-panel-hub/',
    },
    {
      translationKey: 'home-security.door-sensor',
      label: 'Door Sensor',
      to: '/products/door-sensor/',
    },
    {
      translationKey: 'home-security.window-sensor',
      label: 'Window Sensor',
      to: '/products/window-sensor/',
    },
    {
      translationKey: 'home-security.motion-detector',
      label: 'Motion Detector',
      to: '/products/motion-detector/',
    },
    {
      translationKey: 'home-security.glass-break-detector',
      label: 'Glass Break Detector',
      to: '/products/glass-break-detector/',
    },
    {
      translationKey: 'home-security.key-remote',
      label: 'Key Fob',
      to: '/products/key-remote/',
    },
    {
      translationKey: 'home-security.panic-button',
      label: 'Panic Button',
      to: '/products/panic-button/',
    },
    {
      translationKey: 'home-security.siren',
      label: 'Secondary Siren',
      to: '/products/siren/',
    },
  ],
  'Environmental Detectors': [
    {
      translationKey: 'environmental-detectors.environmental-detectors',
      label: 'Environmental Detectors',
      to: '/environmental/',
    },
    {
      translationKey: 'environmental-detectors.smoke-detector',
      label: 'Smoke Detector',
      to: '/products/smoke-detector/',
    },
    {
      translationKey: 'environmental-detectors.co-detector',
      label: 'Carbon Monoxide',
      to: '/products/co-detector/',
    },
    {
      translationKey: 'environmental-detectors.flood-sensor',
      label: 'Water Leak Detector',
      to: '/products/flood-sensor/',
    },
  ],
  Cameras: [
    {
      translationKey: 'cameras.cameras',
      label: 'Cameras',
      to: '/products/cameras/',
    },
    {
      translationKey: 'cameras.indoor-camera',
      label: 'Eufy Indoor Camera',
      to: '/products/indoor-camera/',
    },
    {
      translationKey: 'cameras.outdoor-camera',
      label: 'Eufy Outdoor Camera',
      to: '/products/outdoor-camera/',
    },
    {
      translationKey: 'cameras.doorbell-camera-eufy',
      label: 'Eufy Doorbell Camera',
      to: '/products/doorbell-camera-eufy/',
    },
  ],
  Services: [
    {
      translationKey: 'services.services',
      label: 'Services',
      to: '/services/',
    },
    {
      translationKey: 'services.cove-app',
      label: 'Cove Connect App',
      to: '/cove-app/',
    },
    {
      translationKey: 'services.monitored-security',
      label: 'Professional Monitoring',
      to: '/monitored-security/',
    },
    {
      translationKey: 'services.rapidsos',
      label: 'RapidSOS',
      to: '/rapidsos/',
    },
    {
      translationKey: 'services.professional-installation',
      label: 'Professional Installation',
      to: '/professional-installation/',
    },
  ],
  Company: [
    {
      translationKey: 'company.about-us',
      label: 'About Us',
      to: '/about-us/',
    },
    {
      translationKey: 'company.esf',
      label: 'Elizabeth Smart Foundation',
      to: '/esf-info/',
    },
    {
      translationKey: 'company.accessibility',
      label: 'Accessibility',
      to: '/accessibility/',
    },
    {
      translationKey: 'company.reviews',
      label: 'Reviews',
      to: '/reviews/',
    },
    {
      translationKey: 'company.press',
      label: 'Press Center',
      to: '/press/',
    },
  ],
  Help: [
    {
      translationKey: 'help.help',
      label: 'Help Center',
      to: 'https://support.covesmart.com/',
    },
    {
      translationKey: 'help.contact-us',
      label: 'Contact Us',
      to: '/contact-us/',
    },
    {
      translationKey: 'help.resources',
      label: 'Resources',
      to: '/resources/',
    },
    {
      translationKey: 'help.blog',
      label: 'Articles',
      to: '/blog/',
    },
    {
      translationKey: 'help.phone-number',
      label: '855.268.3669',
      to: 'tel:8552683669',
    },
  ],
  'Exclusive Pricing': [
    {
      translationKey: 'exclusive-pricing.military',
      label: 'Military',
      to: '/military/',
    },
    {
      translationKey: 'exclusive-pricing.medical',
      label: 'Medical Personnel',
      to: '/medical/',
    },
    {
      translationKey: 'exclusive-pricing.teacher',
      label: 'Teachers',
      to: '/teacher/',
    },
    {
      translationKey: 'exclusive-pricing.government-employee',
      label: 'Government Employees',
      to: '/government-employee/',
    },
  ],
};

type LinkHeader = keyof typeof links;
const linkHeaders = Object.keys(links) as LinkHeader[];

const headerTranslationKeys: Record<keyof typeof links, string> = {
  'Home Security': 'home-security.home-security',
  'Environmental Detectors': 'environmental-detectors.environmental-detectors',
  Cameras: 'cameras.cameras',
  Services: 'services.services',
  Company: 'company.company',
  Help: 'help.help',
  'Exclusive Pricing': 'exclusive-pricing.exclusive-pricing',
};

export { links, linkHeaders, headerTranslationKeys };
